// Şoförler ve rehberler (C31–C37): Control yönlendirmeleri (izin + bayrak korumalı, tembel yüklenir).
// Rehber ekranları Okul modülüne bağlı: bayrak kapalıysa ekran açılmaz (menüde de görünmez).
import { Route } from 'react-router';
import { guard, load } from '../route-utils';

const DriverList = load(() => import('./DriverList'), 'DriverList');
const DriverDetail = load(() => import('./DriverDetail'), 'DriverDetail');
const DriverForm = load(() => import('./DriverForm'), 'DriverForm');
const DriverDocuments = load(() => import('./DriverDocuments'), 'DriverDocuments');
const DriverPerformance = load(() => import('./DriverPerformance'), 'DriverPerformance');
const GuideList = load(() => import('./GuideList'), 'GuideList');
const GuideDetail = load(() => import('./GuideDetail'), 'GuideDetail');

export const peopleRoutes = (
  <>
    <Route path="soforler" element={guard(DriverList, 'people')} />
    <Route path="soforler/yeni" element={guard(DriverForm, 'people', { action: 'edit' })} />
    <Route path="soforler/:id" element={guard(DriverDetail, 'people')} />
    <Route path="soforler/:id/duzenle" element={guard(DriverForm, 'people', { action: 'edit' })} />
    <Route path="soforler/:id/belgeler" element={guard(DriverDocuments, 'people')} />
    <Route path="soforler/:id/performans" element={guard(DriverPerformance, 'people')} />
    <Route path="rehberler" element={guard(GuideList, 'people', { flag: 'SCHOOL' })} />
    <Route path="rehberler/:id" element={guard(GuideDetail, 'people', { flag: 'SCHOOL' })} />
  </>
);
